export const roll = [
  {
    id: "1",
    name: "Tortilla Roll",
    price: "350",
  },
  {
    id: "2",
    name: "Spin Roll",
    price: "500",
  },
  {
    id: "3",
    name: "Behari Spin",
    price: "550",
  },
  {
    id: "4",
    name: "Malai Boti Spin Roll",
    price: "500",
  },
  {
    id: "5",
    name: "Chicken Cheese Paratha",
    price: "380",
  },
  {
    id: "6",
    name: "Chicken Cheese Roll",
    price: "330",
  },
  {
    id: "7",
    name: "Chicken Roll",
    price: "250",
  },
  {
    id: "8",
    name: "Chicken Paratha Roll",
    price: "280",
  },
  {
    id: "9",
    name: "Crunch Paratha",
    price: "250",
  },
  {
    id: "10",
    name: "Zinger Paratha",
    price: "400",
  },
  {
    id: "11",
    name: "Kabab Paratha",
    price: "250",
  },
  {
    id: "12",
    name: "Pizza Paratha",
    price: "450",
  },
  {
    id: "13",
    name: "Salad Large",
    price: "350",
  },
  {
    id: "14",
    name: "Salad Medium",
    price: "250",
  },
];
